// src/components/Navbar.js
import { useState, useRef, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";
import { pushToGTM } from "../utils/gtm";

const Navbar = () => {
  const {
    t,
    language,
    translationsEnabled,
    setLanguageFromURL,
    toggleTranslations,
    supportedLanguages,
    getLocalizedPath,
  } = useTranslation();
  const { lang: urlLang } = useParams();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Set language from URL when component mounts or URL changes
  useEffect(() => {
    if (urlLang) {
      setLanguageFromURL(urlLang);
    }
  }, [urlLang, setLanguageFromURL]);

  const handleTranslationsToggle = () => {
    const newStatus = !translationsEnabled;
    toggleTranslations();
    pushToGTM({
      event: "translations_toggle",
      enabled: newStatus,
    });
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar" aria-label={t("navMenu")} role="navigation">
      <div className="nav-container">
        <Link
          to={getLocalizedPath("/")}
          className="nav-logo"
          aria-label="Home page"
          onClick={closeMobileMenu}
        >
          <img src="/bingo/assets/icons/bingologo.svg" />
        </Link>

        <button
          className="mobile-menu-toggle"
          aria-expanded={isMobileMenuOpen}
          aria-controls="nav-menu"
          aria-label="Toggle navigation menu"
          onClick={toggleMobileMenu}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <div
          id="nav-menu"
          ref={menuRef}
          className={`nav-menu ${isMobileMenuOpen ? "nav-menu-open" : ""}`}
          role="menubar"
          aria-label="Main navigation menu"
        >
          {" "}
   
          <Link
            to={getLocalizedPath("/reeglid")}
            className="nav-item"
            role="menuitem"
            onClick={closeMobileMenu}
          >
            {t("rules")}
          </Link>
          {supportedLanguages.map(
            (langCode) =>
              langCode !== language && (
                <Link
                  key={langCode}
                  to={getLocalizedPath("/", langCode)}
                  className={`nav-item ${
                    language === langCode ? "active" : ""
                  }`}
                  onClick={() => {
                    closeMobileMenu();
                    pushToGTM({
                      event: "language_change",
                      language: langCode,
                    });
                  }}
                  role="menuitem"
                  aria-current={language === langCode ? "true" : "false"}
                >
                  {langCode.toUpperCase()}
                </Link>
              )
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
